const en = {
  code: 'en',
  short: 'EN',
  label: 'English',
  native: 'English',
  hero: {
    badge: 'Cleaning Services • Odesa',
    title: 'Pearl of Cleanliness.',
    lead: 'Cleaning for homes and spaces in Odesa.',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Home',
    services: 'Services',
    contact: 'Contact',
    whatsapp: 'WhatsApp',
    language: 'Language'
  },
  home: {
    serviceNote: 'Pearl clean • Odesa • Cleanliness for your space',
    servicesTitle: 'Our Services',
    seeDetails: 'See details →',
    whyTitle: 'Why Pearl clean?',
    reasons: [
      'Services for homes, offices, and commercial spaces',
      'WhatsApp contact available 24/7',
      'Schedule, scope, and details are agreed individually',
      'Prices for core cleaning services'
    ],
    areaTitle: 'Areas we cover',
    areaCopy: 'Odesa and nearby area.',
    quote: 'Get a Quote'
  },
  optional: 'optional',
  servicesPage: {
    title: 'Services',
    subtitle: 'Click a card to open the dedicated page with full checklists, gallery, and pricing notes.'
  },
  notFound: {
    message: 'Page not found.',
    back: 'Go home'
  },
  serviceDetail: {
    notFound: 'Service not found',
    back: 'Back to Services',
    priceLabel: 'Price',
    priceList: 'Price list',
    allServices: 'All services'
  },
  contact: {
    title: 'Contact',
    hours: 'We respond 24/7.',
    phoneLabel: 'Phone',
    locationLabel: 'Location',
    whatsapp: 'Message on WhatsApp',
    office: 'Odesa'
  },
  footer: {
    tagline: 'Cleaning services in Odesa for homes and businesses.',
    rights: 'All rights reserved.',
    getInTouch: 'Get in touch',
    chat: 'Chat on WhatsApp'
  },
  whatsapp: {
    message: 'Hello! I would like to learn more about Pearl clean services in Odesa.'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Basic Cleaning',
      short: 'Essential cleaning for keeping a home or office tidy.',
      intro: 'Basic cleaning helps quickly bring a space back to a clean, orderly state.',
      description: [
        'Our team ensures thorough vacuuming and mopping of all accessible areas, careful dusting of reachable surfaces, and deep cleaning of kitchen and bathroom fixtures — leaving your home fresh, spotless, and comfortable.',
        'Recommended frequency: weekly, bi-weekly, or monthly.'
      ],
      bullets: [
        'Floors vacuumed and mopped',
        'Dusting of reachable surfaces',
        'Bathroom and kitchen fixtures sanitised',
        'Bins emptied and liners replaced'
      ],
      priceNote: 'from 60 UAH/m²'
    },
    {
      slug: 'general-cleaning',
      title: 'General Cleaning',
      short: 'Perfect balance between regular and deep cleaning for a well-maintained home.',
      intro: 'A more detailed cleaning that goes beyond regular maintenance.',
      description: [
        'We include all steps of regular cleaning plus thorough kitchen and bathroom care, covering exterior surfaces, interior oven and refrigerator cleaning, and dedicated pet area refreshes.',
        'Recommended frequency: weekly, every two weeks, or once a month.'
      ],
      bullets: [
        'Regular cleaning checklist included',
        'Kitchen and bathroom detailing',
        'Oven and fridge interior cleaning',
        'Removal of pet hair and cleaning of pet areas (feeding spot, litter box area)'
      ],
      priceNote: 'from 85 UAH/m²'
    },
    {
      slug: 'deep-cleaning',
      title: 'Deep Cleaning',
      short: 'Complete top-to-bottom cleaning for maximum freshness.',
      intro: 'The most detailed cleaning service focused on hard-to-reach areas, deep sanitation, and appliances.',
      description: [
        'Our service includes every step of general cleaning, plus inside-and-outside window cleaning where reachable, interior cleaning of wardrobes and cabinets, and deep treatment of kitchen appliances such as the fridge, oven, and microwave.',
        'Upon request, upholstery, carpet, and balcony cleaning are also available. Recommended whenever you want your home to feel perfectly refreshed.'
      ],
      bullets: [
        'Detailed limescale and grease removal',
        'Cabinets and wardrobes cleaned inside',
        'Windows cleaned inside and outside (reachable)',
        'Appliances deep-cleaned throughout'
      ],
      priceNote: 'from 95 UAH/m²'
    },
    {
      slug: 'upholstery-cleaning',
      title: 'Upholstery Cleaning',
      short: 'Professional cleaning for upholstered furniture, mattresses, and carpets.',
      intro: 'We refresh furniture and textiles with each item priced separately.',
      description: ['Choose the items you need from the price list.'],
      priceNote: 'Prices are per item unless otherwise stated.',
      priceItems: [
        { id: 'two-seat-sofa', title: '2-seat sofa', price: 'from 1,000 UAH' },
        { id: 'three-seat-sofa', title: '3-seat sofa', price: 'from 1,300 UAH' },
        { id: 'large-straight-sofa', title: 'Large straight sofa', price: 'from 1,500 UAH' },
        { id: 'corner-sofa', title: 'Corner sofa', price: 'from 1,500 UAH' },
        { id: 'large-corner-sofa', title: 'Large corner sofa', price: 'from 1,800 UAH' },
        { id: 'armchair', title: 'Armchair', price: 'from 400 UAH' },
        { id: 'pouf', title: 'Pouf', price: 'from 250 UAH' },
        { id: 'backless-chair', title: 'Backless chair', price: 'from 120 UAH' },
        { id: 'chair-with-back', title: 'Chair with backrest', price: 'from 180 UAH' },
        { id: 'sofa-pillow', title: 'Sofa cushion', price: 'from 100 UAH' },
        { id: 'single-mattress', title: 'Single mattress', price: 'from 800 UAH' },
        { id: 'double-mattress', title: 'Double mattress', price: 'from 1,100 UAH' },
        { id: 'carpet', title: 'Carpet / carpet flooring', price: 'from 70 UAH/m²' }
      ]
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Post-Construction Cleaning',
      short: 'Remove dust, paint, and debris after renovation.',
      intro: 'Professional cleaning after renovation or construction work.',
      description: [
        'We remove dust, glue, paint, and debris, clean windows, floors, surfaces, and bathrooms so the property is move-in ready — fresh, spotless, and dust-free.'
      ],
      bullets: [
        'Removal of construction dust and debris',
        'Detailing of fixtures, sockets, and switches',
        'Window, frame, and sill cleaning',
        'Final polish of floors and surfaces'
      ],
      priceNote: 'from ₴___'
    },
    {
      slug: 'move-in-move-out',
      title: 'Move-In / Move-Out Cleaning',
      short: 'Ideal for new beginnings or smooth transitions.',
      intro: 'Detailed cleaning to help you hand over or move into a spotless home.',
      description: [
        'We focus on cupboards, appliances, skirting boards, and fixtures to make sure the property is immaculate for landlords or new owners.',
        'Perfect before listing, inspections, or settling into a new space.'
      ],
      bullets: [
        'Cabinets and drawers cleaned inside',
        'Appliance interiors degreased',
        'Windows and frames wiped down',
        'Attention to details such as baseboards and switches'
      ],
      priceNote: 'from ₴___'
    },
    {
      slug: 'office-cleaning',
      title: 'Office Cleaning',
      short: 'Keep your workspace spotless and productive.',
      intro: 'Maintain a pristine and organised workspace with our professional office cleaning service.',
      description: [
        'We ensure thorough cleaning of all areas — from workstations and meeting rooms to kitchens and sanitary facilities — creating a spotless and hygienic environment.',
        'Our trained team works with precision and discretion, helping your company maintain a professional image and a comfortable atmosphere for employees and clients.'
      ],
      bullets: [
        'Workstations, meeting rooms, and reception areas',
        'Washrooms and kitchenettes sanitised',
        'Bins emptied and recycling managed',
        'Flexible schedules outside working hours'
      ],
      priceNote: 'from ₴___'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Commercial Cleaning',
      short: 'Professional service for restaurants, hotels, and shops.',
      intro: 'Create a spotless and welcoming environment for your customers and staff.',
      description: [
        'We provide high-standard cleaning for restaurants, hotels, shops, salons, fitness centres, and offices, ensuring every area looks pristine and feels hygienic.',
        'Our trained team focuses on detail — from shining floors and polished furniture to disinfected kitchens and restrooms. We use eco-friendly solutions and reliable methods to guarantee safety, freshness, and comfort in your business space.',
        'Pearl clean offers flexible schedules and personalised cleaning plans to suit your working hours, ensuring minimal disruption to your operations.'
      ],
      bullets: [
        'Front-of-house, back-of-house, and storage areas',
        'Disinfection of high-touch surfaces',
        'Floor care for hard surfaces and carpets',
        'Custom schedules for each business type'
      ],
      priceNote: 'from ₴___'
    },
    {
      slug: 'window-cleaning',
      title: 'Window Cleaning',
      short: 'Crystal-clear windows inside and out.',
      intro: 'Crystal-clear windows make every space brighter.',
      description: [
        'Our team provides professional window cleaning services for apartments, offices, and commercial spaces — both inside and outside (reachable areas only).',
        'We use eco-friendly and streak-free products, leaving glass spotless and frames shining without damage. Regular window cleaning enhances natural light, creates a fresh atmosphere, and keeps your space looking professional.'
      ],
      bullets: [
        'Interior and reachable exterior glass',
        'Frames, sills, and tracks wiped',
        'Streak-free, eco-friendly products',
        'Ideal for homes, offices, and storefronts'
      ],
      priceNote: 'from ₴___'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Carpet & Upholstery Cleaning',
      short: 'Deep cleaning and refreshing of carpets and upholstered furniture.',
      intro: 'Restore softness and remove odours from carpets, sofas, and chairs.',
      description: [
        'We treat stains, allergens, and build-up with professional equipment tailored to fabric type, leaving textiles revitalised and fresh.',
        'Ideal as an add-on to deep cleaning or as a standalone refresh for high-traffic homes and commercial lounges.'
      ],
      bullets: [
        'Hot-water extraction or low-moisture methods',
        'Targeted stain and odour removal',
        'Safe solutions for delicate fabrics',
        'Fast drying times to reduce downtime'
      ],
      priceNote: 'from ₴___'
    }
  ]
};

export default en;
